// extracted by mini-css-extract-plugin
module.exports = {"tagGroup":"tips_tagGroup__klG6w","tips1":"tips_tips1__4MT7a","placeHolder":"tips_placeHolder__T7h8U","tips2":"tips_tips2__pgQGz"};